// extracted by mini-css-extract-plugin
module.exports = {"study-badge":"style_study-badge__wXvPa","badge-title":"style_badge-title__1U61f","badge-value":"style_badge-value__1rBCi","badge-bottom-text":"style_badge-bottom-text__rEpgC"};